import { captureMessage } from "@sentry/react";
import { g } from "analytics";
import { reauthFromCurrentLogin } from "api/auth/reauth";
import { CommonModal } from "components/common_modal";
import Flags from "flags";
import { t } from "i18next";
import * as React from 'react';
import { Toastr } from "setup";
import appStore from "store/store";
import { Disclaimer, PlansGrid } from "tiers/promo_plus";
import { ComparisonTable } from "tiers/promo_table";
import { Toast } from "toast";
import { Consts } from "vars";
import { callApi } from "../api/api";
import { isSafari } from "../utils";
/** Maximum number of liquid layers that Boost users can add to a container. */
export const MAX_BOOST_DIAGRAM_LAYERS = 5;
/** Maximum number of diagrams that Boost users can store in cloud. */
export const BOOST_TOTAL_DIAGRAMS = 150;
/** Maximum number of diagrams that free users can store in cloud. */
export const FREE_TOTAL_DIAGRAMS = 3;
/** Number of item customisations */
export const ITEM_CUSTOMISATIONS = "200+";
export class PlusPromoModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            schoolPlanStudents: 0,
            schoolPlanMaxDiagrams: 0,
            teamMembers: 0,
        };
    }
    checkout(plan, currency, interval) {
        g("CheckoutButtonClick", this.props.analyticsTag);
        const request = {
            plan: plan,
            currency: currency,
            interval: interval,
            scheme: Flags.is2025PricingEnabled ? "2025" : "2022",
        };
        // On Safari, we need to open the window immediately, otherwise it gets
        // blocked and it's hard to open it.
        // https://stackoverflow.com/questions/20696041/window-openurl-blank-not-working-on-imac-safari
        let windowReferenceForSafari;
        if (isSafari()) {
            windowReferenceForSafari = window.open();
            windowReferenceForSafari === null || windowReferenceForSafari === void 0 ? void 0 : windowReferenceForSafari.document.write("<html><body><center style='margin-top:5em'>Retrieving information, please wait...</center></body></html>");
        }
        callApi("plans/createCheckoutSession", "POST", appStore.loggedInState(), request, {
            success: response => {
                var _a;
                // There are two cases:
                if (response.sessionId) {
                    // 1) User does not yet have a plan. Checkout session has been created.
                    const sessionId = response.sessionId;
                    const checkoutUrl = `./checkout.html?sessionId=${sessionId}&stripePk=${Consts.stripePublicKey}`;
                    if (windowReferenceForSafari) {
                        // For Safari, just assign the location.
                        windowReferenceForSafari.location.href = checkoutUrl;
                    }
                    else {
                        // Otherwise use window.open.
                        window.open(checkoutUrl);
                    }
                    g("CheckoutWindowOpen", this.props.analyticsTag);
                }
                else if (response.tier) {
                    const tier = response.tier;
                    reauthFromCurrentLogin();
                    Toast.success(t("promo.checkout_success.description"), t("promo.checkout_success.title", { tier: (_a = tier === null || tier === void 0 ? void 0 : tier.capitalise()) !== null && _a !== void 0 ? _a : "" }));
                    this.props.setIsOpen(false);
                    g("CheckoutWindowOpen", "RecoverSuccess");
                }
                else {
                    // Unknown case.
                    captureMessage("Unexpected response from createCheckoutSession", "error");
                }
            },
            special: error => {
                if (error.error_type === "conflicting_currency") {
                    Toast.warning(t("promo.currency_error.description")
                        + Toastr.contactSupportButton("openRequestCurrencyFix"), t("promo.currency_error.title"));
                    return true;
                }
                return false;
            }
        });
    }
    render() {
        return React.createElement(CommonModal, { isOpen: this.props.isOpen, setIsOpen: this.props.setIsOpen, extraClass: "promo-modal wide", title: t("promo.title"), icon: "fa-bolt-lightning" },
            React.createElement(PlansGrid, { currentTier: this.props.tier, defaultCurrency: this.props.defaultCurrency, onCheckout: (plan, currency, interval) => this.checkout(plan, currency, interval), signedIn: this.props.auth.state == "logged_in", onClose: () => this.props.setIsOpen(false), onUpdateSchoolPlan: ({ students, maxDiagrams }) => this.setState({ schoolPlanStudents: students, schoolPlanMaxDiagrams: maxDiagrams }), onUpdateTeamPlan: ({ teamMembers }) => this.setState({ teamMembers }), analyticsTag: this.props.analyticsTag }),
            React.createElement(Disclaimer, null),
            React.createElement(ComparisonTable, { students: this.state.schoolPlanStudents, members: this.state.teamMembers, maxDiagrams: this.state.schoolPlanMaxDiagrams }));
    }
}
export const fadColors = (primary, secondary) => ({
    "--fa-primary-color": primary,
    "--fa-secondary-color": secondary,
    "--fa-secondary-opacity": 1.0,
});
